import { CacheService } from 'web_core_library';
import { BRIDGE_CACHE_TIMEOUT } from './constants';
import * as Types from './types';

let _userId = 0;
let _triggerCacheKey = '';
let _actionsCacheKey = '';

async function init(userId: number) {
  _userId = userId;
  _triggerCacheKey = `${_userId}-bridge-trigger`;
  _actionsCacheKey = `${_userId}-bridge-actions`;
  await CacheService.init();
}

function isReady() {
  return _userId !== 0;
}

async function getTriggers() {
  const triggerBase = await CacheService.load<Types.IBridgeTriggerCache>(_triggerCacheKey);
  return triggerBase || {};
}

function setTriggers(triggerBase: Types.IBridgeTriggerCache) {
  return CacheService.save(_triggerCacheKey, triggerBase);
}

async function getActions() {
  const timestamp = Date.now();
  const cache = await CacheService.load<Types.IBridgeActionCache>(_actionsCacheKey);
  if (!cache) {
    return;
  }
  if (timestamp - cache.timestamp > BRIDGE_CACHE_TIMEOUT) {
    return;
  }
  return cache.actions;
}

function setActions(actions: Types.IBridgeAction[]) {
  const timestamp = Date.now();
  const cache: Types.IBridgeActionCache = {
    timestamp,
    actions,
  };
  return CacheService.save(_actionsCacheKey, cache);
}

function resetActions() {
  return CacheService.save(_actionsCacheKey, undefined);
}

const BridgeCacheService = {
  init,
  isReady,
  getTriggers,
  setTriggers,
  getActions,
  setActions,
  resetActions,
};
export default BridgeCacheService;
